<template>
  <v-card>
    <!-- <v-list>
      <v-list-item three-line>

	          <v-list-item-avatar :size="48" color="secondary">
	            <v-flex class="text-center white--text">{{ author_inititals }}</v-flex>
	          </v-list-item-avatar>

	          <v-list-item-content>
	            <v-list-item-title>{{ author_name }}</v-list-item-title>
	            <v-list-item-subtitle>{{ trans(`advert.owner_type_${owner_type}`) }}</v-list-item-subtitle>
	            <v-list-item-subtitle>{{ trans('user.last_online') }} {{ last_active }}</v-list-item-subtitle>
	          </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="mb-2">
            <v-icon small left v-if="email_verified">mdi-check-circle</v-icon>
            <v-icon small left v-if="!email_verified">mdi-close-circle</v-icon>
            <span>{{ trans('user.email_verified') }}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="mb-2">
            <v-icon small left v-if="phone_number_verified">mdi-check-circle</v-icon>
            <v-icon small left v-if="!phone_number_verified">mdi-close-circle</v-icon>
            <span>{{ trans('user.phone_number_verified') }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>-->

    <v-divider></v-divider>

    <v-card-text>
      <div
        class="caption font-weight-bold text-center mb-2"
      >{{ trans('advert.title_contact', null ,'Contact Information') }}</div>
      <contact-form v-if="uuid" :username="author_name" :to="uuid">
        <template v-slot:default="{on}">
          <v-btn
            color="primary"
            large
            block
            rounded
            :disabled="!email"
            v-on="on"
          >{{ trans('app.contact_advertiser_email') }}</v-btn>
        </template>
      </contact-form>

      <v-btn
        class="mt-4"
        color="secondary"
        outlined
        large
        block
        rounded
        :disabled="!phone_number"
        @click="showPhone"
        v-if="show_phone != true"
      >{{ trans('app.contact_advertiser_phone') }}</v-btn>

      <div class="mt-4" v-if="show_phone">
        <v-text-field
          class="text-center"
          :value="phone_number"
          :single-line="true"
          @click:append="copyPhone"
          append-icon="mdi-content-copy"
          hide-details
          readonly
          solo
          :suffix="is_copied ? 'Copied' : ''"
        ></v-text-field>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <slot></slot>
  </v-card>
</template>
<script>
import _ from "lodash";
import ContactForm from "./ContactForm";

export default {
  components: {
    "contact-form": ContactForm
  },

  data: () => ({
    show_phone: false,
    is_copied: false
  }),

  methods: {
    showPhone: function() {
      if (this.show_phone) return;
      this.show_phone = true;
      setTimeout(() => (this.show_phone = false), 10000);
    },
    copyPhone: function() {
      this.$clipboard(this.phone_number);
      this.is_copied = true;
      setTimeout(() => (this.is_copied = false), 1500);
    }
  },

  computed: {
    author_first_name: function() {
      let name = _.get(this.$props, "first_name", null);
      if (name == null || name == "") return "app.anonymous_user";
      return name;
    },

    author_last_name: function() {
      let name = _.get(this.$props, "last_name", null);
      if (name == null || name == "") return null;
    },

    author_name: function() {
      if (this.$props.last_name_visible && this.author_last_name) {
        return this.author_first_name + " " + this.author_last_name;
      } else {
        return this.author_first_name;
      }
    },

    author_inititals: function() {
      let inititals = this.author_first_name.charAt(0);
      if (this.$props.last_name_visible && this.author_last_name) {
        inititals = inititals + "" + this.author_last_name;
      }
      return _.toUpper(inititals);
    },

    last_active: function() {
      let last_active_at = _.get(
        this.$props,
        "activity.last_active_at",
        _.get(this.$props, "created_at", null)
      );
      return this.moment(last_active_at);
    },

    owner_type: function() {
      return _.get(this.$props.advert, "owner_type", null);
    }
  },

  props: [
    "role",
    "locale",
    "email",
    "phone_number",
    "first_name",
    "last_name",
    "email_visible",
    "phone_number_visible",
    "last_name_visible",
    "email_verified",
    "phone_number_verified",
    "provider",
    "locked_at",
    "deleted_at",
    "filled",
    "activity", // -> "last_active_at"
    "advert",
    "uuid"
  ]
};
</script>